import { queryOptions } from '@tanstack/react-query'
import { CARRIER_PREFIX, deleteRequest, getRequest, postRequest } from 'global/helpers/requests'
import { sleep } from 'global/helpers/sleep'
import type { CreateOrEditDriverFormValues, DriverData } from './DriverManager.types'

export const DRIVERS_QUERY_KEY = 'drivers'

export const getDrivers = async (): Promise<DriverData[]> => {
  const drivers = await getRequest<DriverData[]>('drivers', {}, CARRIER_PREFIX)
  return drivers.map(processDriver).sort(sortDrivers)
}

export const driversQueryOptions = queryOptions({
  queryKey: [DRIVERS_QUERY_KEY],
  queryFn: getDrivers,
})

export const createDriver = async (data: CreateOrEditDriverFormValues): Promise<void> => {
  const response = await postRequest<void>('drivers', {
    body: {
      ...data,
      language: data.language?.toUpperCase().replace('-', '_'),
    },
  }, CARRIER_PREFIX)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}

// NOTE: for now looks the same as createDriver above, this should be changed with the carrier management service introduction
export const editDriver = async (data: CreateOrEditDriverFormValues): Promise<void> => {
  const response = await createDriver(data)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}

export const deleteDriver = async (driverCid: string): Promise<void> => {
  const response = await deleteRequest<void>(`drivers/${driverCid}`, {}, CARRIER_PREFIX)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}

const processDriver = (driver: DriverData): DriverData => ({
  ...driver,
  language: driver.language?.toLowerCase().replace('_', '-'),
})

const sortDrivers = (a: DriverData, b: DriverData): number => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
